import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var logInRes;
export const logInTodo = createAsyncThunk('logIn', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'login',
            data: {
                "name": data.username,
                "password": data.password,
                "vcustomer_code":data.vcustomer_code
              
            },
            headers: { "Content-Type": "application/json" }
        })
        return logInRes = res.data

    } catch (error) {
        return logInRes = error.response.data
    }
})


